import { Helmet } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Publications from './components/Publications';
import Projects from './components/Projects';
import Courses from './components/Courses';
import Contact from './components/Contact';
import Labs from './components/Labs';


export default function App() {
    return (
        <>
            <Helmet>
                <title>Dr. Priyanka Katiyar - Associate Professor at Shiv Nadar University</title>
                <meta name="description" content="Dr. Priyanka Katiyar is an Associate Professor at Shiv Nadar University, specializing in Biofuels, Membrane Separation, and Catalysis. Expert in Chemical Engineering research." />
                <meta name="keywords" content="Dr. Priyanka Katiyar, Chemical Engineering, Biofuels, Membrane Separation, Supercritical Fluid Extraction, Catalysis, Shiv Nadar University" />
                <meta property="og:title" content="Dr. Priyanka Katiyar - Chemical Engineering Professor & Researcher" />
                <meta property="og:description" content="Expert in Biofuels, Membrane Separation, and Catalysis. Associate Professor at Shiv Nadar University with extensive research experience." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.priyankakatiyar.me" />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://www.priyankakatiyar.me" />
                <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "Person",
                            "name": "Dr. Priyanka Katiyar",
                            "jobTitle": "Associate Professor",
                            "worksFor": {
                                "@type": "Organization",
                                "name": "Shiv Nadar University"
                            },
                            "alumniOf": "IIT Roorkee",
                            "description": "PHD and Chemical Engineering professor specializing in Biofuels and Membrane Separation",
                            "url": "https://www.priyankakatiyar.me",
                            "sameAs": [
                                "https://www.linkedin.com/in/priyanka-k-3930a852/",
                                "https://scholar.google.com/citations?hl=en&authuser=1&user=lLEBAwQAAAAJ",
                                "https://www.researchgate.net/profile/Priyanka-Priyanka-3"
                            ]
                        }
                    `}
                </script>
            </Helmet>
            <div className="min-h-screen flex flex-col bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark transition-colors duration-300">
                <Navbar />
                <main className="flex-grow px-4 md:px-8 pt-24 flex flex-col items-center">
                    <Home />
                    <About />
                    <Projects />
                    <Publications />
                    <Labs />
                    <Courses />
                    <Contact />
                </main>
                <footer className="text-center text-gray-600 dark:text-gray-400 text-sm p-4 border-t border-gray-300 dark:border-gray-700">
                    &copy; {new Date().getFullYear()} Dr. Priyanka Katiyar. All rights reserved.
                </footer>
            </div>
            <Analytics />
        </>
    );
}